/**
 * Die Jahre, zwischen denen die Auswertung umschalten laesst.
 *
 * Die Liste beginnt im Jahr, in dem die Patientenanfragen eingefuehrt wurden, und waechst
 * von selbst weiter: Am 1. Januar steht das neue Jahr da, ohne dass jemand etwas aendern
 * muss. Eine feste Zahl zurueckliegender Jahre waere falsch in beide Richtungen — sie
 * boete Jahre an, in denen es das Feature nicht gab, und fiele irgendwann hinten ab.
 */
export const ERSTES_JAHR_DER_PATIENTENANFRAGEN = 2026;

export const waehlbareJahre = (aktuellesJahr: number): string[] => {
  const letztes = Math.max(aktuellesJahr, ERSTES_JAHR_DER_PATIENTENANFRAGEN);
  const anzahl = letztes - ERSTES_JAHR_DER_PATIENTENANFRAGEN + 1;

  return ["all", ...Array.from({ length: anzahl }, (_, i) => String(letztes - i))];
};
